import React, { useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation } from 'react-router-dom';

const PurchasedDataUnit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const[ButData,setButData]=useState({
     SDL:"" ,
     Instrumente:"",
     TimeModus:"",
     Market:"",
     Time:""
})
const handleChange = (event) => {
     setButData({...ButData,[event.target.name]: event.target.value,});
};
    console.log('location', location)
    
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname=="/admin-panel/CheckProviderDetail/PermissionsDetail"? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='RegisterProviderText'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Purchased Data Units</span> 
   {/* <Button onClick={()=>{
    navigate('/admin-panel/CheckProviderDetail/RegisterNewDataProvider');
   }}  variant="contained">Register New Data Provider</Button>  */}
    </div>     
   

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                           
                            <div style={{width:"98%",marginTop:40}}>
                                <components.Table.PurchasedDataUnitTable/>    
                            </div>  
                            
            </div>
         
</div>}
</>
  )
}

export default PurchasedDataUnit